import { Container } from "@/components/ui";

import { useParticipantIds } from "@daily-co/daily-react";
import { useLocalSessionId } from "@daily-co/daily-react";
import { useAtomValue } from "jotai";
import { translatorIdAtom } from "../atoms/videoCallAtoms";
import { useDailyErrorHandling } from "../hooks/useDailyErrorHandling";
import { useDailyEventHandling } from "../hooks/useDailyEventHandling";
import { CallPanelTile } from "./CallPanelTile";
import { TranslatorTile } from "./TranslatorTile";

interface CallPanelProps {
  useEventHandling?: () => void;
  useErrorHandling?: () => void;
}

export const CallPanel = ({
  useEventHandling = useDailyEventHandling,
  useErrorHandling = useDailyErrorHandling,
}: CallPanelProps) => {
  useErrorHandling();
  useEventHandling();
  const localSessionId = useLocalSessionId();
  const remoteParticipantIds = useParticipantIds({ filter: "remote" });
  const translatorId = useAtomValue(translatorIdAtom);
  const patientId = remoteParticipantIds.find((id) => id !== translatorId);

  return (
    <Container direction="column" className="relative">
      {patientId ? (
        <CallPanelTile participantId={patientId} />
      ) : (
        <div className="bg-black h-full w-full" />
      )}
      <div className="absolute w-[100px] flex flex-col gap-1">
        <CallPanelTile participantId={localSessionId} isSelf />
        {translatorId && <TranslatorTile participantId={translatorId} />}
      </div>
    </Container>
  );
};
